class CertificadosVencidosModalController {
    constructor(certificados, scope, modalInstance) {
        this.scope = scope
        this.modalInstance = modalInstance
        this.certificados = certificados

        this.timer = 10
        this.runTimer()
    }

    runTimer() {
        setTimeout(() => {
            if (this.timer > 0) {
                this.scope.$apply(() => this.timer -= 1)
                this.runTimer()
            }
        }, 1000)
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular.module("eficienciaFiscalModule")
    .controller("certificadosVencidosModalController", ["certificados", "$scope", "$uibModalInstance", CertificadosVencidosModalController])
